/**
 * Created by ronmarsiano on 16/08/2017.
 */
mainApp.directive('singleNetworkRule', function() {
    return {
        templateUrl: '/public/directives/singleNetworkRule.html',
        controller:  ['$scope', '$state', '$element', "LocationService", "$filter", "$timeout", "NetworkRulesService", function($scope, $state, $element, LocationService, $filter, $timeout, NetworkRulesService) {



            function initRoutingSelections() {
                $scope.primaryTransports = $scope.tableConfig.transports[$scope.item.toType];
                $scope.transports = $scope.primaryTransports.filter(function(transport) {
                    return transport.value != NetworkRulesService.offCloudKey;
                });
                $scope.NICs = $scope.tableConfig.NICs[$scope.item.toType];
                $scope.NICs.sort(function(a,b) {
                    if(a.label < b.label) {return -1;}
                    else if(b.label < a.label) {return 1;}
                    return 0;
                });
            }

            $scope.showExcep = false;
            $scope.showEdit = false;
            $scope.selectedLocations=[];
            $scope.routeMessage;
            $scope.showEdit = {};

            $scope.originalActiveTcpAccelerationIsDisplaySet = null;
            $scope.originalActiveTcpAccelerationIsCheckBoxSet = null;

            var $el = $($element[0]);

            initRoutingSelections();

            $scope.$watch('item', function(newValue, oldValue) {
                if (oldValue === newValue)
                    return;

                if (newValue.priority !== oldValue.priority) { // items changed priority
                    initRoutingSelections();
                    $scope.generateSummaries();
                    return;
                }

                if (newValue.primaryTransport !== oldValue.primaryTransport) {
                    if (newValue.primaryTransport === $scope.item.secondaryTransport)
                        $scope.item.secondaryTransport = '';

                    if(!$scope.isPrimaryTransportCatoSelected()) {
                        $scope.item.primarySocketInterfaceRoleForPrimaryTransport = NetworkRulesService.autoKey;
                    }
                    $scope.updateActiveTcpAcceleration();
                }

                if (newValue.secondaryTransport !== oldValue.secondaryTransport) {
                    if(!$scope.isSecondaryTransportCatoSelected()) {
                        $scope.item.primarySocketInterfaceRoleForSecondaryTransport = NetworkRulesService.autoKey;
                    }
                    $scope.updateActiveTcpAcceleration();
                }
                if (newValue.primarySocketInterfaceRoleForPrimaryTransport !== oldValue.primarySocketInterfaceRoleForPrimaryTransport) {
                    if (oldValue.primarySocketInterfaceRoleForPrimaryTransport === NetworkRulesService.autoKey)
                        $scope.item.secondarySocketInterfaceRoleForPrimaryTransport = NetworkRulesService.autoKey;

                    if (newValue.primarySocketInterfaceRoleForPrimaryTransport === $scope.item.secondarySocketInterfaceRoleForPrimaryTransport || newValue.primarySocketInterfaceRoleForPrimaryTransport === NetworkRulesService.autoKey)
                        $scope.item.secondarySocketInterfaceRoleForPrimaryTransport = '';
                }
                if (newValue.primarySocketInterfaceRoleForSecondaryTransport !== oldValue.primarySocketInterfaceRoleForSecondaryTransport) {
                    if ($scope.item.primarySocketInterfaceRoleForSecondaryTransport == null && $scope.item.secondaryTransport == NetworkRulesService.catoKey)
                        $scope.item.primarySocketInterfaceRoleForSecondaryTransport = 'NONE';

                    if (oldValue.primarySocketInterfaceRoleForSecondaryTransport === NetworkRulesService.autoKey)
                        $scope.item.secondarySocketInterfaceRoleForSecondaryTransport = NetworkRulesService.autoKey;

                    if ((newValue.primarySocketInterfaceRoleForSecondaryTransport === $scope.item.secondarySocketInterfaceRoleForSecondaryTransport && newValue != 'NONE') || newValue.primarySocketInterfaceRoleForSecondaryTransport === NetworkRulesService.autoKey)
                        $scope.item.secondarySocketInterfaceRoleForSecondaryTransport = '';
                }
                if (newValue.routeType !== oldValue.routeType) {
                    $scope.updateActiveTcpAcceleration();
                }


            }, true);

            /**
             * Updating activeTcpAcceleration value when routeType is routeVia/NAT and primary/secondary Transport is set to Alternative WAN accordingly - set activeTcpAcceleration to true/false and disable the checkbox.
             * Save previous setup in cache in case user will selected/un-selected one of the cases which automatically change activeTcpAcceleration value.
             */
            $scope.updateActiveTcpAcceleration = function(){
                if ($scope.item.toType === 'Internet'){
                    if ($scope.item.routeType === 'VIA' || $scope.item.routeType === 'NAT'){
                        $scope.isActiveTcpAccelerationNeedToBeDisabled = true;
                        $scope.setOriginalActiveTcpAccelerationFields();
                        $scope.item.activeTcpAcceleration = true;

                        return true;
                    }else{
                        if ($scope.originalActiveTcpAccelerationIsDisplaySet){
                            $scope.resetActiveTCPAccelerationStatus();
                        }
                    }
                } else if ($scope.item.toType === 'WAN'){
                    if ($scope.item.primaryTransport === '_ALTERNATIVE_WAN' || $scope.item.secondaryTransport === '_ALTERNATIVE_WAN' ||
                        $scope.item.primaryTransport === NetworkRulesService.offCloudKey || $scope.item.secondaryTransport === NetworkRulesService.offCloudKey){
                        $scope.isActiveTcpAccelerationNeedToBeDisabled = true;
                        $scope.setOriginalActiveTcpAccelerationFields();
                        $scope.item.activeTcpAcceleration = false;

                        return true;
                    }else{
                        if ($scope.originalActiveTcpAccelerationIsDisplaySet){
                            $scope.resetActiveTCPAccelerationStatus();
                        }
                    }
                }
            };

            /**
             * Reset to default settings.
             */
            $scope.resetActiveTCPAccelerationStatus = function(){
                $scope.isActiveTcpAccelerationNeedToBeDisabled = false;
                $scope.item.activeTcpAcceleration = $scope.originalActiveTcpAccelerationIsCheckBoxSet;
                $scope.originalActiveTcpAccelerationIsDisplaySet = null;
            }

            /**
             * Reset to the default state before disabled and updated activeTcpAcceleration.
             */
            $scope.setOriginalActiveTcpAccelerationFields = function() {
                if ($scope.originalActiveTcpAccelerationIsDisplaySet == null){
                    $scope.originalActiveTcpAccelerationIsDisplaySet = true;
                    $scope.originalActiveTcpAccelerationIsCheckBoxSet = $scope.item.activeTcpAcceleration;
                }
            };

            $scope.isActiveTcpAccelerationNeedToBeDisabled = $scope.updateActiveTcpAcceleration();

            $scope.isCatoSelected = function() {
                return $scope.item.primaryTransport === NetworkRulesService.catoKey ||
                    $scope.item.secondaryTransport === NetworkRulesService.catoKey
            };

            $scope.isAlternativeWANSelected = function(){
                return $scope.item.primaryTransport == "_ALTERNATIVE_WAN" || $scope.item.secondaryTransport == "_ALTERNATIVE_WAN";
            };

            $scope.isPrimaryTransportCatoSelected = function() {
                return $scope.item.primaryTransport === NetworkRulesService.catoKey;
            };
            $scope.isPrimaryNICAutoForPrimaryTransport = function() {
                return $scope.item.primarySocketInterfaceRoleForPrimaryTransport === NetworkRulesService.autoKey;
            };
            $scope.isSecondaryTransportCatoSelected = function() {
                return $scope.item.secondaryTransport === NetworkRulesService.catoKey;
            };
            $scope.isPrimaryNICAutoForSecondaryTransport = function() {
                return $scope.item.primarySocketInterfaceRoleForSecondaryTransport === NetworkRulesService.autoKey;
            };

            $scope.shouldShowInterfaceConf = function(transport) {
                return transport === NetworkRulesService.catoKey;
            };

            $scope.clickRadioButton = function ($event,value) {
                $event.stopPropagation();
                $scope.item.routeType = value;
            };

            $scope.clearSelection = function ($event) {
                $event.stopPropagation();
                $scope.item.routeType = null;
            };

            /**
             * function for enlarging the row upon click
             */
            function enlargeRow() {
                $el.clearQueue();
                $el.children('div').animate({
                    height: '100%'
                }, 300, 'swing');
            }

            /**
             * function for minimizing the row upon click
             */
            function minimizeRow() {
                $el.clearQueue();
                $el.children('div').animate({
                    height: '110px'
                }, 300, 'swing');
            }

            $scope.$watch('item.wasSaved', function(newValue, oldValue) {
                if($scope.item.wasSaved && oldValue != true){
                    if (!_.isEqual(newValue, oldValue)) {
                        delete $scope.item.wasSaved;
                        $scope.generateSummaries();

                        if ($scope.item.routeType !== 'VIA') {
                            $scope.item.locations = [];
                        }
                        else if ($scope.item.routeType !== 'NAT') {
                            $scope.item.allocatedIps = [];
                            $scope.item.crossConnectNat = [];
                        }
                        else if ($scope.item.routeType !== 'OPTIMIZED') {
                            $scope.item.allocatedIps = [];
                            $scope.item.crossConnectNat = [];
                        }
                    }
                }
            }, true);

            /**
             * this function is applied upon selection of the single
             * network rule and will trigger the animation
             */
            $scope.showEditMode = function ($event, type) {
                $event.stopPropagation();
                $scope.showEdit[type] = !$scope.showEdit[type];

                var $targetEl = $($event.currentTarget);

                var $expandedEl = $targetEl.siblings('.bottom-expanded');
                $expandedEl.clearQueue();
                if ($scope.showEdit[type]) {
                    $expandedEl.slideDown(300);
                } else {
                    $expandedEl.slideUp(300);
                }
                $scope.generateRoutingSummary();
                $targetEl.find('.toggle-btn').toggleClass('open');
            };

            $scope.showExceptions = function ($event) {
                $scope.showExcep = !$scope.showExcep;
                $event.stopPropagation();
            };

            $scope.stopProp = function ($event) {
                $event.stopPropagation();
            };

            /**
             * method for creating rule summery
             * @returns {*}
             */
            $scope.generateRoutingSummary = function () {
                var locationArray = [];
                if (!$scope.$root || !$scope.$root.tags) {
                    return;
                }
                if (!LocationService.hasLocationForAccount($state.params.accountId)) {
                	$timeout(function() {
                    	$scope.generateRoutingSummary();
                    }, 50, false);
                    return;
                }
                var ret = "";

                if($scope.item.routeType == "NONE"){
                    ret = ret + "None";
                }
                else if ($scope.item.routeType == "VIA"){
                    if($scope.item.locations.length ==0)
                        ret = ret + "Location not selected";
                    $scope.item.locations.forEach(function (locationId) {
                        var location = LocationService.getPopLocationViaLocationId($state.params.accountId, locationId.id);
                        if (shouldInsertLocation(locationArray,location)) {
                            if(ret != ""){
                                ret = ret + "," +  location.name;
                            }
                            else{
                                ret = ret + location.name;
                            }
                        }
                    });


                }
                else if($scope.item.routeType == "NAT"){
                    if($scope.item.allocatedIps.length ==0 && $scope.item.crossConnectNat.length ==0 )
                        ret = ret + "No IP is selected";

                    $scope.item.allocatedIps.forEach(function (allocatedIp) {
                        var location = LocationService.getPopLocationViaLocationId($state.params.accountId, allocatedIp.locationId);
                        if(shouldInsertLocation(locationArray,location)){
                            if(ret != ""){
                                ret = ret + "," +  location.name;
                            }
                            else{
                                ret = ret + location.name;
                            }
                        }
                    });

                    $scope.item.crossConnectNat.forEach(function (publishedIp) {
                         var location = LocationService.getPopLocationViaLocationId($state.params.accountId, publishedIp.locationId);
                         if (shouldInsertLocation(locationArray,location)) {
                             if(ret != ""){
                                 ret = ret + "," +  location.name;
                             }
                             else{
                                 ret = ret + location.name;
                             }
                         }
                     });
                }
                else if($scope.item.routeType == "OPTIMIZED"){
                    ret = ret + "Optimized Access";
                }

                var primaryTransport = _.findWhere($scope.primaryTransports, {value: $scope.item.primaryTransport});
                var secondaryTransport = _.findWhere($scope.transports, {value: $scope.item.secondaryTransport});
                if (ret !== '') {
                    ret += ', ';
                }
                ret += ' Transport: ' + primaryTransport.label + (secondaryTransport ? ' with fallback to ' + secondaryTransport.label : '');
                if ($scope.isCatoSelected()) {
                    var primarySocketInterfaceRole = null;
                    var secondarySocketInterfaceRole = null;

                    if ($scope.isPrimaryTransportCatoSelected()){
                        primarySocketInterfaceRole = _.findWhere($scope.NICs, {value: $scope.item.primarySocketInterfaceRoleForPrimaryTransport});
                        secondarySocketInterfaceRole = _.findWhere($scope.NICs, {value: $scope.item.secondarySocketInterfaceRoleForPrimaryTransport});
                    }
                    if ($scope.isSecondaryTransportCatoSelected()){
                        primarySocketInterfaceRole = _.findWhere($scope.NICs, {value: $scope.item.primarySocketInterfaceRoleForSecondaryTransport});
                        secondarySocketInterfaceRole = _.findWhere($scope.NICs, {value: $scope.item.secondarySocketInterfaceRoleForSecondaryTransport});
                    }

                    if (ret !== '') {
                        ret += ', ';
                    }
                    ret += (primarySocketInterfaceRole ? ' NIC: ' + primarySocketInterfaceRole.label : '') + (secondarySocketInterfaceRole ? ' with fallback to ' + secondarySocketInterfaceRole.label : '');
                }


                $scope.routeMessage = ret;
                return  $scope.routeMessage;
            };

            /**
             * returns true if we need to insert the location into the summery or not
             * we do so to avoid repeating the same location
             *
             * @param locationArray
             * @param location
             * @returns {boolean}
             */
            function shouldInsertLocation(locationArray,location) {
                if(locationArray && location &&
                    location.name && locationArray.indexOf(location.name) == -1){
                    locationArray.push(location.name);
                    return true;
                }
                return false;
            }

            $scope.generateOptimizationsSummary = function() {
                if (!$scope.$root || !$scope.$root.tags) {
                    return;
                }
                var ret = "";

                if ($scope.item.activeTcpAcceleration) {
                    ret += 'TCP Acceleration ON';
                }
                if ($scope.item.sslAcceleration) {
                    if (ret !== '') {
                        ret += ', ';
                    }
                    ret += 'SSL Acceleration ON';
                }

                if ($scope.item.packetLossMitigationEnabled) {
                    if (ret !== '') {
                        ret += ', ';
                    }
                    ret += 'Packet Loss Mitigation ON';
                }

                $scope.optimizationsMessage = ret;
                return $scope.optimizationsMessage;
            };

            $scope.generateBwSummary = function(item) {
                if (!$scope.$root || !$scope.$root.tags) {
                    return;
                }
                var ret = "";
                if (item.qosPriority) {
                    var priorityLabel = $scope.tableConfig.qosPriorities.filter(function(p) {return p.value==item.qosPriority});
                    ret = 'Priority: ' + ((priorityLabel[0]) ? priorityLabel[0].label : '');
                }

                $scope.item.$bwMessage = ret;
                return $scope.item.$bwMessage;
            };

            $scope.hasExceptions = function() {
                return !((!$scope.item.toException || $scope.item.toException.length === 0) && (!$scope.item.fromException || $scope.item.fromException.length === 0) && (!$scope.item.whatException || $scope.item.whatException.length === 0));
            };

            $scope.generateSummaries = function() {
                $scope.generateRoutingSummary();
                $scope.generateOptimizationsSummary();
                $scope.generateBwSummary($scope.item);
            };
        }]
    };
});
